module.exports = __webpack_public_path__ + "fonts/drop-menu-s.96a85ba0b5183039afb435bb6df9e47f.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/indicators/drop-menu-s.png
// module id = 803
// module chunks = 9